import { useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import { AppLayout, PageHeader } from "@/components/Layout";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { HelpCircle } from "lucide-react";

export default function Faq() {
  const [faqs, setFaqs] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.get("/faqs").then((r) => setFaqs(r.data)).catch(() => {}).finally(() => setLoaded(true));
  }, []);

  const grouped = useMemo(() => {
    const g = {};
    faqs.forEach((f) => { const c = f.category || "General"; (g[c] = g[c] || []).push(f); });
    return g;
  }, [faqs]);

  const categories = Object.keys(grouped);

  return (
    <AppLayout>
      <PageHeader subtitle="Know Before You Go" title="FAQ & Info" />
      <div className="space-y-5 px-4 pt-2" data-testid="faq-page">
        {loaded && faqs.length === 0 && (
          <div className="rounded-xl border border-dashed border-border bg-card/50 p-6 text-center">
            <HelpCircle size={30} className="mx-auto text-muted-foreground/40" />
            <p className="mt-3 text-sm text-muted-foreground" data-testid="faq-empty">
              Frequently asked questions will be posted here soon.
            </p>
          </div>
        )}
        {categories.map((cat) => (
          <div key={cat} data-testid={`faq-category-${cat}`}>
            <h2 className="mb-1 text-xs font-bold uppercase tracking-widest text-secondary">{cat}</h2>
            <div className="rounded-xl border border-border bg-card px-4 shadow-sm">
              <Accordion type="single" collapsible>
                {grouped[cat].map((f) => (
                  <AccordionItem key={f.id} value={f.id} data-testid={`faq-item-${f.id}`}>
                    <AccordionTrigger className="font-display text-base font-semibold text-primary">
                      {f.question}
                    </AccordionTrigger>
                    <AccordionContent>
                      <p className="whitespace-pre-line leading-relaxed text-foreground/80">
                        {f.answer ? f.answer : <span className="italic text-muted-foreground">Answer coming soon.</span>}
                      </p>
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
          </div>
        ))}
      </div>
    </AppLayout>
  );
}
